'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _immutable2 = _interopRequireDefault(_immutable);

var _actionNames = require('../utils/actionNames');

var _create = require('./create');

var _create2 = _interopRequireDefault(_create);

var _fetch = require('./fetch');

var _fetch2 = _interopRequireDefault(_fetch);

var _update = require('./update');

var _update2 = _interopRequireDefault(_update);

var _remove = require('./remove');

var _remove2 = _interopRequireDefault(_remove);

var _bulk = require('./bulk');

var _bulk2 = _interopRequireDefault(_bulk);

var _perform = require('./perform');

var _perform2 = _interopRequireDefault(_perform);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates a reducer with the provided config
 * @param  {Object} config - reducer configuration
 *
 * @return {Function} - Reducer function
 */
var reducer = function reducer(config) {

  if (!config) throw new Error('clerk.reducer: Expected config');
  if (!config.actionPrefix) throw new Error('clerk.reducer: Expected actionPrefix');

  // Generate action names for create, fetch, update, remove, bulk
  var createActions = (0, _actionNames.generateActionNames)(config.actionPrefix, 'create');
  var fetchActions = (0, _actionNames.generateActionNames)(config.actionPrefix, 'fetch');
  var updateActions = (0, _actionNames.generateActionNames)(config.actionPrefix, 'update');
  var removeActions = (0, _actionNames.generateActionNames)(config.actionPrefix, 'remove');
  var bulkActions = (0, _actionNames.generateActionNames)(config.actionPrefix, 'bulk');
  var performActions = (0, _actionNames.generateActionNames)(config.actionPrefix, 'perform');

  var defaultState = _immutable2.default.fromJS({

    // raw: Contains raw data objects
    // {
    //   123: { ... },
    //   234: { ... }
    // }
    raw: {},

    // pendingRaw: Contains pending updates made to data objects
    // {
    //   123: { ... },
    //   234: { ... }
    // }
    pendingRaw: {},

    // Holds uids of pending items
    // {
    //   create: [123],
    //   update: [234, 345],
    //   remove: [456]
    // }
    pending: {
      create: [],
      update: [],
      remove: []
    },

    // Holds derived subsets of the raw data
    // Stored as arrays of uids
    // {
    //   instance1: { data: [123, 234] },
    //   instance2: { [234,345,456] }
    // }
    instances: {}
  });

  // Clerk reducer
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.Map({});
    var action = arguments[1];


    // Extend existing state
    // This comes into play when clerk is used to extend an existing reducer
    // We use mergeWith so that our default state doesn't blow away any exiting values
    state = state.mergeWith(function (a) {
      return a;
    }, defaultState);

    switch (action.type) {
      case fetchActions.start:
        return _fetch2.default.start(state, action);
      case fetchActions.success:
        return _fetch2.default.success(state, action);
      case fetchActions.error:
        return _fetch2.default.error(state, action);
      case createActions.start:
        return _create2.default.start(state, action);
      case createActions.success:
        return _create2.default.success(state, action);
      case createActions.error:
        return _create2.default.error(state, action);
      case updateActions.start:
        return _update2.default.start(state, action);
      case updateActions.success:
        return _update2.default.success(state, action);
      case updateActions.error:
        return _update2.default.error(state, action);
      case removeActions.start:
        return _remove2.default.start(state, action);
      case removeActions.success:
        return _remove2.default.success(state, action);
      case removeActions.error:
        return _remove2.default.error(state, action);
      case bulkActions.start:
        return _bulk2.default.start(state, action);
      case bulkActions.success:
        return _bulk2.default.success(state, action);
      case bulkActions.error:
        return _bulk2.default.error(state, action);
      case performActions.start:
        return _perform2.default.start(state, action);
      case performActions.success:
        return _perform2.default.success(state, action);
      case performActions.error:
        return _perform2.default.error(state, action);
      default:
        return state;
    }
  };
};

exports.default = reducer;